<script>
  import { onMount } from "svelte";

  export let product;
  export let dynamic;

  // If it's not dynamic, then we've already loaded the stock
  let stockLoaded = !dynamic;

  onMount(() => {
    if (dynamic && !stockLoaded) {
      // To get the stock, we actually need to get the variants
      // by loading them in via the GraphQL Storefront API
      product.loadVariants().then(() => {
        stockLoaded = true;
      });
    }
  });
</script>

{#if stockLoaded}
  <div>
    <div class="
        polygon--stock-label
        {['In Stock', 'Coming Soon'].includes(product.stockLabel) ? 'bg-brand-electric' : ''}
        {product.stockLabel === 'Pre-order' ? 'bg-brand-blue-light text-black' : ''}
        {product.stockLabel === 'Out of stock' ? 'bg-white\/60 text-black' : ''}
        {product.stockLabel === 'Sold Out' ? 'bg-red-500 text-white' : ''}
        pl-1.5 pr-2 py-[2px] inline-block b5 font-medium mt-1
    ">
      {product.stockLabel}
    </div>
  </div>
{/if}
